export default "__VITE_ASSET__WBWllSYf__"